/*
 * @Author: your name
 * @Date: 2020-04-22 10:08:34
 * @LastEditTime: 2020-04-29 18:29:18
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Dropdown\schema.ts
 */
import { DataType } from "@cloudpivot/form/typings";
import { selectControlOptions } from "@cloudpivot/form/component-schema";
export default {
    $id: "dataselect",
    type: DataType.Object,
    $ref: selectControlOptions.$id,
    properties: {
        options: {
            type: DataType.String,
            title: "选项",
            default: "",
        },
        widgetType: {
            type: DataType.Number,
            title: "控件类型",
        },
        dataItemType: {
            type: DataType.String,
            title: "数据项类型",
        },
        displayEmpty: {
            type: DataType.Boolean,
            title: "是否显示空选项",
            default: true,
        },
        multi: {
            type: DataType.Boolean,
            title: "是否多选",
            default: true,
        },
        dataLinkage: {
            type: DataType.String,
            title: "数据联动",
        },
        fileRootNode: {
            type: DataType.Object,
            title: "文档根节点",
            default: {},
        },
        documentRoot: {
            type: DataType.Object,
            title: "文档根节点",
            default: {},
        },
        fileType: {
            type: DataType.String,
            title: "展示方式",
            default: 'file',
        },
        libraryCode: {
            type: DataType.String,
            title: "选择库"
            // default: 'yuanshi',
        },
        countLimit: {
            type: DataType.String,
            title: "数量限制"
        },
        displayDownload: {
            type: DataType.String,
            title: "是否下载",
            default: '2',
        },
    },
};
